import React, { useCallback } from 'react';

import * as BaseSwitch from '@twilio-paste/core/switch';
import type { FieldHookConfig } from 'formik';
import { useField } from 'formik';


export type SwitchProps = Omit<FieldHookConfig<unknown>, 'ref' | 'onChange'> &
  Omit<BaseSwitch.SwitchProps, 'onChange'> & { onChange?: (value: boolean) => void };

export function Switch({ children, helpText, name, disabled, onChange, ...props }: SwitchProps) {
  const [{ value, onChange: onFieldChange, ...field }, meta] = useField({
    name,
    type: 'checkbox',
  });

  const handleChange = useCallback(() => {
    onFieldChange({ target: { name, value: !value } });
    onChange?.(!value);
  }, [name, value, onFieldChange, onChange]);

  return (
    <BaseSwitch.Switch
      {...props}
      {...field}
      id={name}
      name={name}
      checked={value}
      helpText={helpText}
      hasError={meta.touched && !!meta.error}
      disabled={disabled}
      onChange={handleChange}
    >
      {children}
    </BaseSwitch.Switch>
  );
}
